import { Button } from '@optools/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@optools/components/ui/dropdown-menu';
import { MediaPlaylist } from 'hls.js';

export interface AudioSelectorProps {
  audioTracks: MediaPlaylist[] | undefined;
  onTrackSelected: (index: number) => void;
  selectedTrackIndex: number;
}

export function AudioSelector({
  audioTracks,
  onTrackSelected,
  selectedTrackIndex,
}: AudioSelectorProps) {
  const onValueChangeHandler = (value: string) => {
    const trackIndex = Number(value);
    if (isNaN(trackIndex)) {
      console.log(`Provided value of ${value} is not a number.`);
    }
    onTrackSelected(trackIndex);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button aria-label="Audio track selector" className="min-w-36" size="sm">
          {audioTracks?.[selectedTrackIndex]?.name ?? 'Undefined'}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuLabel>Audio Tracks</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuRadioGroup
          value={selectedTrackIndex.toString()}
          onValueChange={onValueChangeHandler}>
          {audioTracks?.map((track, index) => (
            <DropdownMenuRadioItem key={track.id} value={index.toString()}>
              {track.name}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
